import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoPro2docsGetRes } from "./abst/DtoPro2docsGetRes";

export class DtoPro2docsGetResImple extends DtoPro2docsGetRes {
  public pager = new DtoApiPager();
}
